import { Type } from 'class-transformer';
import { ArrayMaxSize, ArrayMinSize, IsArray, ValidateNested } from 'class-validator';

import { CreateDraftDto } from './create-draft.dto';
import { MAX_BULK_DRAFT_ORDERS } from './draft-bulk.constants';

export class CreateDraftsBulkDto {
  /**
   * Array of draft creation payloads to process in a single request. Min 1 Max 1500.
   */
  @IsArray()
  @ArrayMinSize(1)
  @ArrayMaxSize(MAX_BULK_DRAFT_ORDERS)
  @ValidateNested({ each: true })
  @Type(() => CreateDraftDto)
  public drafts: CreateDraftDto[];
}
